import { Autocomplete, createTheme, MantineThemeOverride, MultiSelect, NumberInput, PasswordInput, Select, TagsInput, Textarea, TextInput } from "@mantine/core"
import { DateInput, DatePickerInput, DateTimePicker } from "@mantine/dates"

export const themeOverride = createTheme({
  primaryColor: "biocells-green",
  colors: {
    "biocells-green": ["#E9EDC6", "#DAE2A2", "#CBD77F", "#BCCB5C", "#ADC039", "#9EB516", "#8A9E13", "#768710", "#62700D", "#4E590A"],
    "biocells-red": ["#FEF2F2", "#FDE8E8", "#FECACA", "#FCA5A5", "#F87171", "#EF4444", "#DC2626", "#B91C1C", "#991B1B", "#7F1D1D"]
  },
  components: {
    DateInput: DateInput.extend({ defaultProps: { radius: "md" } }),
    DateTimePicker: DateTimePicker.extend({ defaultProps: { radius: "md" } }),
    DatePickerInput: DatePickerInput.extend({ defaultProps: { radius: "md" } }),
    NumberInput: NumberInput.extend({ defaultProps: { radius: "md" } }),
    PasswordInput: PasswordInput.extend({ defaultProps: { radius: "md" } }),
    Select: Select.extend({ defaultProps: { radius: "md" } }),
    TextInput: TextInput.extend({ defaultProps: { radius: "md" } }),
    Textarea: Textarea.extend({ defaultProps: { radius: "md" } }),
    TagsInput: TagsInput.extend({ defaultProps: { radius: "md" } }),
    Autocomplete: Autocomplete.extend({ defaultProps: { radius: "md" } }),
    MultiSelect: MultiSelect.extend({ defaultProps: { radius: "md" } })
  },
  cursorType: "pointer"
}) satisfies MantineThemeOverride
